module.exports = function strRepeat(str, qty){
  if (qty < 1) return '';
  var result = '';
  while (qty > 0) {
    if (qty & 1) result += str;
    qty >>= 1, str += str;
  }
  return result;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/helper/strRepeat.js
 ** module id = 252
 ** module chunks = 0
 **/